<template>
  <MenuItem
    class="h7-text-medium"
    icon-color="grey"
    :label="$t('Common.Theme')"
    @click="toggleTheme">
    <div
      slot="content"
      class="theme-row">
      <div>
        <template v-if="userTheme === 'dark-theme'">
          🌙
        </template>
        <template v-else>
          ☀️
        </template>
      </div>
      <div class="my-auto">
        {{ $t('Common.ColorCheme') }}
      </div>
    </div>
  </MenuItem>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import theme from 'mixins/theme'

export default {
  mixins: [ theme ],
  methods: {
    toggleTheme() {
      const activeTheme = localStorage.getItem('user-theme') ?? 'light-theme'
      if (activeTheme === 'light-theme') {
        this.setTheme('dark-theme')
      } else {
        this.setTheme('light-theme')
      }
    },
  },
  components: {
    MenuItem
  }
}
</script>
<style scoped>
.menu-item-label {
  min-width: calc(100% - 25px);
}
.theme-row {
  display: grid;
  grid-template-columns: 30px 1fr;
}
</style>
